import { HTTP_STATUS_CODES, PASSENGER_TYPE } from "app/constants";
import cloneDeep from "lodash/cloneDeep";

export const buildBookingUpdatedData = (quotationFromQuery = {}) => {
	const passengers = [];

	for (let i = 0; i < quotationFromQuery?.adults; i++) {
		passengers.push({
			type: PASSENGER_TYPE.ADULT,
			index: i + 1,
		});
	}

	for (let i = 0; i < quotationFromQuery?.children; i++) {
		passengers.push({
			type: PASSENGER_TYPE.CHILD,
			index: i + 1,
			birthdate: quotationFromQuery?.childrenBirthdates
				? quotationFromQuery?.childrenBirthdates[i]
				: {},
		});
	}

	for (let i = 0; i < quotationFromQuery?.infants; i++) {
		passengers.push({
			type: PASSENGER_TYPE.INFANT,
			index: i + 1,
			birthdate: quotationFromQuery?.infantsBirthdates
				? quotationFromQuery?.infantsBirthdates[i]
				: {},
		});
	}

	return {
		offer: {
			label: quotationFromQuery?.offerLabel,
			type: quotationFromQuery?.offerType,
			contractType: quotationFromQuery?.contractType,
			negotiated: quotationFromQuery?.negotiated || [],
		},
		departureCity: {
			code: quotationFromQuery?.departureCityCode,
			label: quotationFromQuery?.departureCityLabel,
		},
		rentalAccommodation: {
			accommodation: quotationFromQuery?.accommodationLabel,
		},
		departureDate: quotationFromQuery?.departureDate,
		endDate: quotationFromQuery?.endDate,
		duration: { value: quotationFromQuery?.duration },
		adults: quotationFromQuery?.adults || 0,
		children: quotationFromQuery?.children || 0,
		infants: quotationFromQuery?.infants || 0,
		passengers: passengers,
		price: quotationFromQuery?.price,
	};
};

export const buildQuotationPayload = ({ quotationPayload = {}, sessionBiid }) => {
	// cloneDeep au lieu de Object.assign pour eviter de modifier le childrenBirthdatesdu payload source
	const quotationPayloadCopy = cloneDeep(quotationPayload);

	if (sessionBiid) {
		quotationPayloadCopy.sessionBiid = sessionBiid;
	}

	// On incremente le mois car le service attend 1 pour janvier par exemple
	const childrenBirthdates = quotationPayloadCopy?.childrenBirthdates
		? quotationPayloadCopy.childrenBirthdates.map(birthdate => {
				birthdate.month = birthdate.month + 1;
				return birthdate;
			})
		: [];

	const infantsBirthdates = quotationPayloadCopy?.infantsBirthdates
		? quotationPayloadCopy.infantsBirthdates.map(birthdate => {
				birthdate.month = birthdate.month + 1;
				return birthdate;
			})
		: [];

	quotationPayloadCopy.childrenBirthdates = childrenBirthdates;
	quotationPayloadCopy.infantsBirthdates = infantsBirthdates;

	return quotationPayloadCopy;
};

export const hasFlightOptionsFailed = response => {
	const flightOptionsHttpStatus = response.status;

	const errorCodes = [
		HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
		HTTP_STATUS_CODES.GATEWAY_TIMEOUT,
		HTTP_STATUS_CODES.BAD_REQUEST,
		HTTP_STATUS_CODES.FORBIDDEN,
	];

	return !flightOptionsHttpStatus || errorCodes.includes(response.status);
};
